import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("input", _mergeProps({ class: "hidden-input" }, _ctx.$attrs, { tabindex: "-1" }), null, 16));
}
